// extracted by mini-css-extract-plugin
module.exports = {"button":"CategoryResultCard_button__FFJKH","wrapper":"CategoryResultCard_wrapper__3vfAW","image":"CategoryResultCard_image__1B1-0","label":"CategoryResultCard_label__3xI_Q"};